/* eslint-disable react/no-access-state-in-setstate */
import React, { Component } from 'react';
import { Translate, I18n } from 'react-redux-i18n';
import { connect } from 'react-redux';
import FIELDS from '../../data/fields';
import DropZoneComponent from '../dropzone';

import {
  getCategoriesAction, createCategoryAction, updateCategoryAction, updateCategoryImage,
} from '../../app/store/actions/categories';

class CategoryFormComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      name: '',
      parentId: '',
      message: '',
      success: '',
      id: '',
      file: '',
      loadImage: false,
      isSustainable: false,
      description: '',
    };
  }

  componentDidMount = () => {
    if (this.props.back.location.category) {
      const comming = this.props.back.location;
      if (this.props.back.location.parent) {
        this.setState({
          parentId: comming.parent.id,
          id: comming.category.id,
          name: comming.category.name,
          isSustainable: comming.category.isSustainable,
          description: comming.category.description,
        });
      } else {
        this.setState({
          parentId: null,
          id: comming.category.id,
          name: comming.category.name,
          isSustainable: comming.category.isSustainable,
          description: comming.category.description,
        });
      }
    }
  };

  goBack = () => {
    this.props.back.goBack();
  };

  getCategories = (categories, parentComming) => categories.map(category => (
    <React.Fragment key={category.id}>
      <option
        key={category.id}
        value={category.id}
        selected={parentComming && parentComming.id === category.id}
      >
        {category.name}
      </option>
    </React.Fragment>
  ));

  createCategory = async () => {
    let { parentId } = this.state;
    const {
      file, name, isSustainable, description,
    } = this.state;
    if (!parentId) parentId = null;
    if (!name) {
      this.setState({ message: I18n.t('categoryName'), success: '' });
      return;
    }
    try {
      const newCategory = await this.props.createCategory({
        name, parentId, isSustainable, description,
      });
      this.setState({
        name: '', success: I18n.t('categorySaved'), message: '',
      });

      if (file && newCategory && newCategory.id) {
        await this.props.updateCategoryImage(file[0], newCategory.id);
      }
    } catch (err) {
      this.setState({ message: I18n.t('errorOcurred'), success: '' });
    }
  };

  updateCategory = async () => {
    const {
      file, name, parentId, id, isSustainable, description,
    } = this.state;
    if (!name) this.setState({ message: I18n.t('categoryName'), success: '' });
    else {
      try {
        await this.props.updateCategory({
          id, name, parentId, isSustainable, description,
        });
        this.setState({
          success: I18n.t('categoryUpdated'), message: '', loadImage: true,
        });

        if (file) await this.props.updateCategoryImage(file[0], id);
      } catch (err) {
        this.setState({ message: I18n.t('errorOcurred'), success: '' });
      } finally {
        this.setState({ loadImage: false, file: '' });
      }
    }
  };

  checkDefault = () => {
    const comming = this.props.back.location.category;
    if (comming === undefined) {
      return false;
    }
    if (comming.isSustainable) {
      return true;
    }
    return false;
  }

  showSustainableCheckbox = (comming) => {
    const { isSustainable } = this.state;

    // eslint-disable-next-line no-prototype-builtins
    if (comming === undefined || comming.hasOwnProperty('isSustainable')) {
      return (
        <React.Fragment>
          <div className="form-check">
            <input
              defaultChecked={this.checkDefault()}
              onChange={() => this.setState({ isSustainable: !isSustainable })}
              type="checkbox"
              className="form-check-input"
            />
            <span><Translate value="categorySustainable" /></span>
          </div>
        </React.Fragment>
      );
    }
  }

  render() {
    const { categories } = this.props;
    const {
      file, loadImage, name, message, success, parentId, description,
    } = this.state;
    const comming = this.props.back.location.category;
    const parentComming = this.props.back.location.parent;

    return (
      <div className="form-main">
        {!parentComming && !parentId && (
        <React.Fragment>
          {comming && (
          <div className="justify-content-center display-flex">
            <img
              src={comming.imageUrl || 'images/default-image.jpg'}
              className="img-logo-banners"
              alt="Logo"
            />
          </div>
          )}
          <div className="row margin-bottom-20 banner-form-div justify-content-center">

            <div className="dropzone-out">
              <DropZoneComponent
                uploadedFile={e => this.setState({ file: e, success: '', message: '' })}
                title={I18n.t('dragCategory')}
                loadImage={loadImage}
                fileName={file && file[0].name}
              />
            </div>
          </div>
        </React.Fragment>
        )}

        <form>
          <div className="form-group">
            <p className="margin-bottom-2">{I18n.t('categoryFather')}</p>
            <select
              className="custom-select"
              required
              onChange={e => this.setState({ parentId: e.target.value })}
              disabled={!parentComming && comming}
            >
              {!parentComming && <option value="">{I18n.t('categoryRoot')}</option>}
              {categories && this.getCategories(categories, parentComming)}
            </select>
            <div className="invalid-feedback"><Translate value="categoryRoot" /></div>
          </div>

          <div className="form-group">
            <p className="margin-bottom-2"><Translate value="categoryName2" /></p>
            <input
              type="text"
              onChange={e => this.setState({ name: e.target.value })}
              value={name}
              className="form-control"
              aria-describedby="name"
              placeholder=""
              maxLength={FIELDS.max}
            />
          </div>

          <div className="form-group">
            <p className="margin-bottom-2"><Translate value="Descrição" /></p>
            <input
              type="text"
              onChange={e => this.setState({ description: e.target.value })}
              value={description}
              className="form-control"
              aria-describedby="description"
              placeholder=""
            />
          </div>

          {this.showSustainableCheckbox(comming)}

          {success && <p className="color-green margin-top-10">{success}</p>}
          {message && <p className="color-red margin-top-10">{message}</p>}

          <div className="row margin-left-0 margin-top-10">
            <button
              type="button"
              onClick={() => this.goBack()}
              className="btn btn-warning margin-right-15"
            >
              <Translate value="return" />
            </button>
            {!comming
              ? (
                <button
                  type="button"
                  className="btn btn-dark"
                  onClick={() => this.createCategory()}
                >
                  <Translate value="save" />
                </button>
              )
              : (
                <button
                  type="button"
                  className="btn btn-dark"
                  onClick={() => this.updateCategory()}
                >
                  <Translate value="update" />
                </button>
              )
            }
          </div>
        </form>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  getCategories: () => dispatch(getCategoriesAction()),
  createCategory: category => dispatch(createCategoryAction(category)),
  updateCategory: category => dispatch(updateCategoryAction(category)),
  updateCategoryImage: (file, categoryId) => dispatch(updateCategoryImage(file, categoryId)),
});

const mapStateToProps = state => ({
  categories: state.categories.categories,
});

export default connect(mapStateToProps, mapDispatchToProps)(CategoryFormComponent);
